export class CountDown extends Phaser.GameObjects.Container {
  private readonly screenWidth;
  private readonly screenHeight;
  private timer;
  private index;
  private countdownLogo;
  private nextDraw;

  constructor(scene, screenWidth, screenHeight) {
    super(scene);
    this.screenWidth = screenWidth;
    this.screenHeight = screenHeight;
    this.index = 5;
    this.addCountdown();
  }

  addCountdown() {
    this.nextDraw = this.scene.add.image(this.screenWidth / 2, this.screenHeight * 0.47, 'next_draw');
    this.nextDraw.setScale(0.6);
    this.nextDraw.setVisible(true);
    this.countdownLogo = this.scene.add.sprite(this.screenWidth / 2, this.screenHeight * 0.67, 'countdown_' + this.index);

    this.scene.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.8, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.timer = this.scene.time.addEvent({
      delay: 900,
      callback: this.updateCountdown,
      callbackScope: this,
      loop: true
    });
  }

  updateCountdown() {
    // texture not loaded yet...
    if (!this.countdownLogo?.texture) return;

    this.scene.tweens.add({
      delay: 0,
      targets: [this.countdownLogo],
      props: { scale: 0.8, alpha: 1 },
      duration: 100,
      yoyo: true
    });
    this.index -= 1;

    if (this.index < 0) {
      this.scene.time.removeEvent(this.timer);
      this.scene.scene.start('SpinScene');
      return;
    } else if (this.index === 0) {
      this.countdownLogo.setX(this.screenWidth * 0.5);
      this.countdownLogo.setY(this.screenHeight * 0.54);
      this.countdownLogo.setDisplaySize(this.screenWidth * 0.5, this.screenHeight / 5);
      this.nextDraw.setVisible(false);
    }

    this.countdownLogo.setTexture('countdown_' + this.index);
  }

  pauseTimer() {
    this.scene.time.paused = true;
  }

  resumeTimer() {
    this.scene.time.paused = false;
  }
}
